import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7327448a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fixed-header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "separator" }, "›", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nav-item no-hover" }, "个股量化", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "separator" }, "›", -1))
const _hoisted_5 = { class: "current" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "page-scroll-container" }
const _hoisted_8 = { class: "content-layout" }
const _hoisted_9 = { class: "top-row" }
const _hoisted_10 = { class: "left-col" }
const _hoisted_11 = { class: "right-col" }
const _hoisted_12 = { class: "bottom-row" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "disclaimer" }, " 本数据基于您自主选择的区间时间进行回测，相关策略仅在对应回测区间内有效，根据公开的历史市场数据及相关量化模型模拟运行生成，仅客观呈现特定历史场景下的理论绩效，不构成任何证券投资建议、交易要约或买卖依据，亦不代表本公司对未来投资收益的任何承诺或保证。回测结果具有固有局限性包括：1.未完全计入交易成本、滑点、税费等实际交易损耗；2.历史数据无法涵盖未来市场波动、政策调整、流动性变化等不可预见因素；3.模型因子及逻辑的有效性可能随市场环境演变而衰减等。过往回测表现与未来实际投资结果无必然关联，投资者应充分认识证券投资的风险性，独立判断、审慎决策，自主承担全部投资风险。 ", -1))

import StarXpGate from '@/components/star/StarXpGate.vue'
import { isXpLowVersion } from '@/utils/xpEnv'
import StarTabBar from '@/components/star/StarTabBar.vue'
import { ref, onMounted, computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useStarTheme, useStarRouter } from '@/utils/useStarTheme'
import { useStarTemplateLock } from '@/utils/useStarTemplateLock'
import { fetchStrategyDetail } from '@/api/starresultApi'
import store from '@/store/index'
import StarTemplateLockMask from '@/components/star/StarTemplateLockMask.vue'
import StrategyDetails from '.././components/StrategyDetails.vue'
import YieldTrend from '.././components/YieldTrend.vue'
import ActionFooter from '.././components/ActionFooter.vue'
import StockOpLog from './components/StockOpLog.vue'
import StrategyHeader from '.././components/StrategyHeader.vue'
import StockInfoCard from './components/StockInfoCard.vue'
import BacktestStatusOverlay from '.././components/BacktestStatusOverlay.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'result',
  setup(__props) {

_useCssVars(_ctx => ({
  "121ab2a7": (_unref(isDark) ? "transparent" : "#f0f2f5"),
  "32b591fe": (_unref(isDark) ? "var(--text-muted)" : "#666666")
}))

const route = useRoute()
const { colors, isDark } = useStarTheme()
const { starPush } = useStarRouter()
const activeTopTab = ref('home')
const yieldTrendRef = ref<InstanceType<typeof YieldTrend> | null>(null)
const actionFooterRef = ref<any>(null)
const { templateLockState } = useStarTemplateLock()

const handleTemplateUnlock = () => {
  actionFooterRef.value?.showUnlockDialog?.()
}

// quantType: 1=自定义, 2=AI智能
// isDetails 把"AI 回测中"和"AI 策略已保存详情"区分开了，后者不需要 AI 模式的特殊交互逻辑。
const quantType = computed(() => Number(route.query.quantType) || 1)
const isAi = computed(() => quantType.value === 2 && !route.query.isDetails || quantType.value === 2 &&route.query.fromRecord === '1')

const strategyTabList = [
  { key: 'best-yield', label: '进取型' },
  { key: 'best-winrate', label: '稳健型' },
  { key: 'best-ratio', label: '均衡型' },
]
const aiPriorityMap: Record<string, number> = {
  'best-yield': 1,
  'best-winrate': 2,
  'best-ratio': 3,
}
const activeStrategyTab = ref('best-yield')

const cssVars = computed(() => ({
  '--bg-color': colors.value.bg,
  '--card-bg': colors.value.bgCard,
  '--card-bg-sub': (colors.value as any).bgCardSub || colors.value.bgCard,
  '--text-primary': colors.value.textPrimary,
  '--text-secondary': colors.value.textSecondary,
  '--text-muted': colors.value.textMuted,
  '--border-color': colors.value.border,
  '--accent-color': colors.value.accent,
  '--divider-color': colors.value.divider,
  '--rise-color': '#fe4043',
  '--fall-color': '#39e365',
}))

const goBack = (path: string) => starPush(path)

// 数据
const strategyDetails = ref<any>({})
const baseInfo = ref<any>({})
const aiStrategyMap = ref<Record<string, any>>({})
const holdings = ref<any[]>([])
const tradeID = ref<string>('')
const taskID = ref<string>('')
const backtestStatus = ref<number>(2)
const backtestToast = ref<string>('')
const pageType = ref<number>()
// AI 三个 tab 对应的 key
const AI_TAB_KEY_MAP: Record<string, string> = {
  'best-yield': 'aiProfitFirst',
  'best-winrate': 'aiWinRateFirst',
  'best-ratio': 'aiPLRatioFirst',
}

// 当前展示的策略详情（AI模式下随tab切换）
const currentStrategyDetails = computed(() => {
  if (!isAi.value) return strategyDetails.value
  return aiStrategyMap.value[activeStrategyTab.value] || {}
})

const strategyColor = computed(() => {
  const cumRet = currentStrategyDetails.value?.summary?.cumRet
  if (cumRet == null) return '#ff5c5c'
  if (cumRet > 0) return '#fe4043'
  if (cumRet < 0) return '#39e365'
  return '#888888'
})

const strategyTags = computed(() => {
  const tags: string[] = ['个股量化']
  if (strategyDetails.value?.isSubscribed) tags.push('已订阅')
  return tags
})
const currentTradeID = computed(() => {
  if (!isAi.value) return tradeID.value
  const key = AI_TAB_KEY_MAP[activeStrategyTab.value]
  return strategyDetails.value?.[key]?.tradeId || ''
})

const fetchDetail = async (tid: string) => {
  const token = (route.query.token as string) || ''
  const username = store.state.userInfo?.username || ''
  try {
    const res: any = await fetchStrategyDetail({
      data: { taskID: tid },
      headers: { token, username }
    })
    if (res?.data) {
      const status = res.data.status as number
      backtestStatus.value = status
      backtestToast.value = res.data.toast || ''
      
      strategyDetails.value = res.data
      baseInfo.value = res.data.baseInfo || {}
      taskID.value = res.data?.taskID || tid
      tradeID.value = res.data?.tradeId || ''
      pageType.value = res.data?.pageType || ''
      if (res.data.comResult?.holdings) {
        holdings.value = res.data.comResult.holdings
      }
      // AI模式：将三个策略数据存入 map
      if (isAi.value) {
        const tabKeys = ['best-yield', 'best-winrate', 'best-ratio']
        const dataKeys = ['aiProfitFirst', 'aiWinRateFirst', 'aiPLRatioFirst']
        tabKeys.forEach((tab, i) => {
          if (res.data[dataKeys[i]]) {
            aiStrategyMap.value[tab] = res.data[dataKeys[i]]
          }
        })
      }
    }
  } catch (e) {
    console.error('fetchStrategyDetail error', e)
  }
}

onMounted(() => {
  if (isXpLowVersion(route.query as Record<string, unknown>)) return
  const tid = (route.query.taskID as string) || ''
  if (tid) fetchDetail(tid)
})

const onOverlayRefresh = () => {
  const tid = route.query.taskID as string
  if (tid) fetchDetail(tid)
  yieldTrendRef.value?.reload()
}

watch(() => route.query.taskID, (newVal, oldVal) => {
  if (newVal && newVal !== oldVal) {
    const tid = newVal as string
    fetchDetail(tid)
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(StarXpGate, { na: "starStockResult" }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "star-result-page star-page",
        style: _normalizeStyle(_unref(cssVars))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(StarTabBar, {
            modelValue: activeTopTab.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTopTab).value = $event))
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", {
            class: "breadcrumb",
            style: _normalizeStyle({ background: _unref(isDark) ? '#181818' : '#ffffff' })
          }, [
            _createElementVNode("span", {
              class: "nav-item",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (goBack('/star')))
            }, "首页"),
            _hoisted_2,
            _hoisted_3,
            _hoisted_4,
            _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(isAi) ? '智能回测结果' : _unref(route).query.isfrom == '2' ? '策略详情' :'回测结果'), 1)
          ], 4),
          (_unref(isAi))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "strategy-tabs",
                style: _normalizeStyle({ background: _unref(isDark) ? '#181818' : '#fff' })
              }, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(strategyTabList, (tab) => {
                  return _createElementVNode("div", {
                    key: tab.key,
                    class: _normalizeClass(["strategy-tab", { active: activeStrategyTab.value === tab.key }]),
                    onClick: ($event: any) => (activeStrategyTab.value = tab.key)
                  }, _toDisplayString(tab.label), 11, _hoisted_6)
                }), 64))
              ], 4))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                (_unref(route).query.isDetails)
                  ? (_openBlock(), _createBlock(StrategyHeader, {
                      key: 0,
                      strategyDetails: _unref(currentStrategyDetails),
                      strategyName: _unref(currentStrategyDetails)?.title || (_unref(route).query.stockName as string) || '--',
                      tags: _unref(strategyTags),
                      isDark: _unref(isDark)
                    }, null, 8, ["strategyDetails", "strategyName", "tags", "isDark"]))
                  : _createCommentVNode("", true),
                _createVNode(StockInfoCard, {
                  isDark: _unref(isDark),
                  symbol: baseInfo.value.symbol || '',
                  name: baseInfo.value.name || '',
                  market: baseInfo.value.market || '',
                  lastPx: baseInfo.value.lastFx,
                  pxChangeRate: baseInfo.value.pxChangeRate
                }, null, 8, ["isDark", "symbol", "name", "market", "lastPx", "pxChangeRate"]),
                _createVNode(StrategyDetails, {
                  strategyDetails: _unref(currentStrategyDetails),
                  isDark: _unref(isDark),
                  isFactor: false,
                  isStock: true,
                  isAi: _unref(isAi),
                  strategyTab: activeStrategyTab.value
                }, null, 8, ["strategyDetails", "isDark", "isAi", "strategyTab"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(YieldTrend, {
                  ref_key: "yieldTrendRef",
                  ref: yieldTrendRef,
                  isDark: _unref(isDark),
                  isFactor: false,
                  isAi: _unref(isAi),
                  activeTab: activeStrategyTab.value,
                  strategyColor: _unref(strategyColor),
                  noBuySell: !!strategyDetails.value.noBuySell,
                  pageType: strategyDetails.value.pageType,
                  isStock: true,
                  stockName: baseInfo.value.name || '',
                  stockSymbol: baseInfo.value.symbol || '',
                  stockMarket: baseInfo.value.market || ''
                }, null, 8, ["isDark", "isAi", "activeTab", "strategyColor", "noBuySell", "pageType", "stockName", "stockSymbol", "stockMarket"])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(StarTemplateLockMask, {
                "lock-state": _unref(templateLockState),
                text: "解锁策略明细",
                class: "bottom-lock-wrap",
                onUnlock: handleTemplateUnlock
              }, {
                default: _withCtx(() => [
                  _createVNode(StockOpLog, {
                    isDark: _unref(isDark),
                    taskID: taskID.value,
                    tradeID: _unref(currentTradeID),
                    symbol: baseInfo.value.symbol || '',
                    name: baseInfo.value.name || ''
                  }, null, 8, ["isDark", "taskID", "tradeID", "symbol", "name"])
                ]),
                _: 1
              }, 8, ["lock-state"])
            ]),
            _hoisted_13
          ])
        ]),
        _createVNode(ActionFooter, {
          ref_key: "actionFooterRef",
          ref: actionFooterRef,
          isDark: _unref(isDark),
          aiPriority: _unref(isAi) ? aiPriorityMap[activeStrategyTab.value] : undefined,
          strategyDetails: strategyDetails.value,
          onRefresh: _cache[2] || (_cache[2] = ($event: any) => (fetchDetail(_unref(route).query.taskID as string)))
        }, null, 8, ["isDark", "aiPriority", "strategyDetails"]),
        _createVNode(BacktestStatusOverlay, {
          status: backtestStatus.value,
          "toast-string": backtestToast.value,
          onRefresh: onOverlayRefresh
        }, null, 8, ["status", "toast-string"])
      ], 4)
    ]),
    _: 1
  }))
}
}

})